import { render, staticRenderFns } from "./TeleconsultJoin.vue?vue&type=template&id=4de284b0&scoped=true&"
import script from "./TeleconsultJoin.vue?vue&type=script&lang=js&"
export * from "./TeleconsultJoin.vue?vue&type=script&lang=js&"
import style0 from "./TeleconsultJoin.vue?vue&type=style&index=0&id=4de284b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de284b0",
  null
  
)

export default component.exports